<template>
  <div @click="clickButton"
       class="button-add-guide-point">
    <i :class="iconClass"></i>
    {{buttonName}}
  </div>
</template>

<script>
export default {
  name: 'button-auto-width',
  props: {
    iconClass: {
      type: String,
      default: 'el-icon-circle-plus',
    },
    buttonName: {
      type: String,
      default: '添加',
    },
  },
  methods: {
    clickButton() {
      this.$emit('clickBtn')
    },
  },
}
</script>

<style scoped>
.button-add-guide-point {
  border: 1px dashed lightgray;
  text-align: center;
  padding: 8px;
  margin: 10px 0;
  cursor: pointer;
}

.button-add-guide-point:active {
  background-color: rgb(226, 226, 226);
  border: 1px dashed lightgray;
  text-align: center;
  padding: 8px;
  margin: 10px 0;
  cursor: pointer;
}
</style>